// TODO: Update with real response shapes once provider_type and API contracts are confirmed

export interface ApplicationParams {
  userId: string;
  applicationId: string;
  providerType: string;
}

// get_application_info (check existing application)
export interface ApplicationInfoResponse {
  user_id: string;
  provider_name: string;
  external_application_id: string;
  status: string;
  application_data: {
    template_id: string;
    business_profile: {
      dba_name: string;
      legal_name: string;
      phone_number: string;
      corporate_email: string;
      federal_tax_id: string;
      ownership_type: string;
      years_owned: string;
      website_url: string;
      sic_code: string;
      number_of_location: number;
      product_service_sold: string;
      active_months: string[] | null;
      business_address: {
        address: string;
        city: string;
        state: string;
        zip_code: string;
      };
    };
    transaction_info: {
      largest_transaction_amount: number;
      monthly_sales_volume: number;
    };
    owners: ApplicationOwner[];
  };
  created_at: string;
  updated_at: string;
}

// create_application
export interface CreateApplicationPayload {
  is_personal_guarantor: boolean;
  estimated_highest_transaction_amount: number;
  estimated_average_monthly_volume: number;
  is_business_seasonal: boolean;
  business_seasonal_months: string[];
  add_customer_surcharge: boolean;
  default_credit_card_payment_invoice?: boolean;
}

export interface ApplicationOwner {
  type: string;
  first_name: string;
  last_name: string;
  middle_name: string;
  title: string;
  date_of_birth: string;
  ownership_percentage: number;
  ssn: string;
  residence_address: {
    address: string;
    city: string;
    state: string;
    zip_code: string;
  };
}

export interface CreateApplicationResponse {
  application_id: string;
  status: string;
  application: {
    template_id: string;
    business_profile: {
      dba_name: string;
      legal_name: string;
      phone_number: string;
      corporate_email: string;
      federal_tax_id: string;
      ownership_type: string;
      years_owned: string;
      website_url: string;
      sic_code: string;
      number_of_location: number;
      product_service_sold: string;
      active_months: string[] | null;
      business_address: {
        address: string;
        city: string;
        state: string;
        zip_code: string;
      };
    };
    transaction_info: {
      largest_transaction_amount: number;
      monthly_sales_volume: number;
    };
    owners: ApplicationOwner[];
  };
}

// fees
export interface FeeField {
  label: string;
  description: string;
  value: string;
}

export interface FeeSection {
  section_name: string;
  section_description: string;
  disclaimer: string | null;
  fields: FeeField[];
}

export type FeesResponse = FeeSection[];

export interface AcceptFeesPayload {
  accepted: boolean;
}

// terms_and_conditions
export interface TermsSection {
  property_name: string;
  agreement: string;
  is_consent_required: boolean;
}

export type TermsAndConditionsResponse = TermsSection[];

export interface AcceptTermsPayload {
  accepted: boolean;
}

// submit_application
export interface SubmitApplicationPayload {
  ip_address: string;
  device_info: string;
  browser_info: string;
  fee_account?: {
    payment_method_id: string;
  };
  comment: string;
}

export interface SubmitApplicationResponse {
  [key: string]: unknown;
}

// beneficial_owners
export interface BeneficialOwner {
  // TODO: expand once response shape is known
  [key: string]: unknown;
}

// begin_idv
export interface BeginIdvPayload {
  ip_address: string;
  phone_number: string;
}

export interface IdvQuestion {
  id: number;
  text: string;
  choices?: string[];
}

export interface BeginIdvResponse {
  sessionId: string;
  questions: IdvQuestion[];
}

export const isOtpFlow = (response: BeginIdvResponse): boolean =>
  response.questions.length === 1 && response.questions[0].id === 100;

// complete_idv
export interface IdvAnswer {
  questionId: number;
  answer: string;
}

export interface CompleteIdvPayload {
  sessionId: string;
  answers: IdvAnswer[];
}

export interface CompleteIdvResponse {
  [key: string]: unknown;
}

// status
export interface ApplicationStatusResponse {
  status: string;
  // TODO: expand once response shape is known
  [key: string]: unknown;
}

// documents
export interface DocumentsResponse {
  url?: string;
}
